import { createActionCreator } from 'deox';

import { TProjectExportManualResponse } from '@/services/api/project-export';
import message from '@/utils/message';

// CONSTANTS

export enum EProjectExportManualAction {
  PROJECT_EXPORT_MANUAL = 'PROJECT_EXPORT_MANUAL',
  PROJECT_EXPORT_MANUAL_REQUEST = 'PROJECT_EXPORT_MANUAL_REQUEST',
  PROJECT_EXPORT_MANUAL_SUCCESS = 'PROJECT_EXPORT_MANUAL_SUCCESS',
  PROJECT_EXPORT_MANUAL_FAILED = 'PROJECT_EXPORT_MANUAL_FAILED',
}

// TYPES

export type TProjectExportManualRequest = {
  type: EProjectExportManualAction.PROJECT_EXPORT_MANUAL_REQUEST;
  payload: {
    language: string;
    successCallback?: (response: TProjectExportManualResponse) => void;
    failedCallback?: (err: unknown) => void;
  };
};

export type TProjectExportManualSuccess = {
  type: EProjectExportManualAction.PROJECT_EXPORT_MANUAL_SUCCESS;
  payload: { response: TProjectExportManualResponse };
};

export type TProjectExportManualFailed = { type: EProjectExportManualAction.PROJECT_EXPORT_MANUAL_FAILED };

// FUNCTION

export const projectExportManualAction = {
  request: createActionCreator(
    EProjectExportManualAction.PROJECT_EXPORT_MANUAL_REQUEST,
    (resolve) =>
      (
        language: string,
        successCallback?: (response: TProjectExportManualResponse) => void,
        failedCallback?: (err: unknown) => void,
      ): TProjectExportManualRequest => {
        return resolve({ language, successCallback, failedCallback });
      },
  ),
  success: createActionCreator(
    EProjectExportManualAction.PROJECT_EXPORT_MANUAL_SUCCESS,
    (resolve) =>
      (response: TProjectExportManualResponse): TProjectExportManualSuccess => {
        return resolve({ response });
      },
  ),
  failure: createActionCreator(
    EProjectExportManualAction.PROJECT_EXPORT_MANUAL_FAILED,
    (resolve) =>
      (error: any): TProjectExportManualFailed => {
        message.error('PROJECT_EXPORT_MANUAL_FAILED Action:', error.data.status_message);

        return resolve({ error });
      },
  ),
};
